export default __webpack_public_path__ + "static/media/target.7f989361.svg";